import { useRef, ChangeEvent } from 'react';
import Wrapper from './file_uploader.styled';

type FileUploaderProps = {
  customFileHandler?: (
    event: ChangeEvent<HTMLInputElement>,
    name: string,
  ) => void;
  name?: string;
  text?: string;
  primary?: boolean;
  textcolor?: boolean;
  className?: string;
  bg?: string;
  width?: string;
  children?: any; // TODO fix any
};

const FileUploader = ({
  customFileHandler,
  name,
  text,
  textcolor,
  className,
  bg,
  width,
  children,
}: FileUploaderProps) => {
  const hiddenFileInput = useRef<HTMLInputElement>(null);

  const handleClick = () => {
    hiddenFileInput.current?.click();
  };

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    if (customFileHandler) {
      customFileHandler(event, name || '');
    }
  };

  return (
    <div>
      <Wrapper
        onClick={handleClick}
        textcolor={textcolor}
        bg={bg}
        className={className}
        width={width}
      >
        {text}
        {children}
        <input
          accept={'image/*, image/jpeg, image/jpg, application/pdf'}
          type="file"
          name={name}
          ref={hiddenFileInput}
          onChange={customFileHandler ? handleChange : undefined}
          style={{ display: 'none' }}
        />
      </Wrapper>
    </div>
  );
};

export default FileUploader;
